import React from 'react'
import styles from './index.module.scss'
import SuccessIcon from '../../assets/success-icon.svg'
import ErrorIcon from '../../assets/error-icon.svg'
import InfoIcon from '../../assets/info-icon.svg'
import {
    EmailShareButton,
    EmailIcon,
    FacebookShareButton,
    FacebookIcon,
    TelegramShareButton,
    TelegramIcon,
    WhatsappShareButton,
    WhatsappIcon,
    TwitterShareButton,
    XIcon,
  } from "react-share";

const RegistrationModal = ({type, open, setOpen}) => {
    const [showSocials, setShowSocials] = React.useState(false)
    const shareUrl = "https://ubf.ng/register"
    const hashTag = "#UBFEasterConference2025"
    const title = "UBF Easter Conference 2025"
    const body = "Join us for the UBF Easter Conference 2025"

    const closeModal = () => {
        setOpen(false)
    }

    const getModalType = () => {
        switch(type){
            case 'success':
                return {
                    icon: SuccessIcon,
                    class: styles.modal_success,
                    heading: 'Registration Successful',
                    body: 'Your registration was successful. You will receive an email with the conference details',
                    btnText: 'Share',
                    btnAction: () => setShowSocials(true)
                }
            case 'error':
                return {
                    icon: ErrorIcon,
                    class: styles.modal_error,
                    heading: 'Server Error',
                    body: 'Registration was not completed due to server error.',
                    btnText: 'Try Again',
                    btnAction: () => closeModal()
                }
            case 'info':
                return {
                    icon: InfoIcon,
                    class: styles.modal_info,
                    heading: 'Registration Closed',
                    body: 'Sorry registration has closed for the year. Contact us for further assistance.',
                    btnText: 'Contact Us',
                    btnAction: () => window.location.href = "mailto:nigeriaubf@gmail.com"
                }
            default:
                return {
                    icon: SuccessIcon,
                    class: styles.modal_success,
                    heading: 'Registration Successful',
                    body: 'Your registration was successful. You will receive an email with the conference details',
                    btnText: 'Share',
                    btnAction: () => setShowSocials(true)
                }
        }
    }

    if(!open) return null

    return (
        <div className={styles.modal_overlay}>
            <div className={styles.modal_container}>
                <div className={styles.modal_content}>
                    <div className={styles.modal_header}>
                        <div className={styles.modal_icon}>
                            <img src={getModalType(type).icon} alt='modal icon' />
                        </div>
                        <h3>{getModalType(type).heading}</h3>
                    </div>
                    <div className={styles.modal_body}>
                        <p>{getModalType(type).body}</p>
                    </div>
                    <div className={styles.modal_footer}>
                        <button className={styles.modal_btn} onClick={() => closeModal()}>Cancel</button>
                        <button 
                            className={`${styles.modal_btn} ${getModalType(type).class}`}
                            onClick={getModalType(type).btnAction}
                        >{getModalType(type).btnText}</button>
                    </div>
                    {
                        showSocials &&
                        <div className={styles.social_icons}>
                            <EmailShareButton
                                url={shareUrl}
                                subject={title}
                                body={body}
                            >
                                <EmailIcon 
                                    size={32} 
                                    round={true} 
                                />
                            </EmailShareButton>
                            <FacebookShareButton 
                                url={shareUrl}
                                hashtag={hashTag}
                            >
                                <FacebookIcon 
                                    size={32} 
                                    round={true} 
                                />
                            </FacebookShareButton>
                            <TelegramShareButton
                                url={shareUrl}
                                title={body}
                            >
                                <TelegramIcon
                                    size={32} 
                                    round={true} 
                                />
                            </TelegramShareButton>
                            <WhatsappShareButton
                                url={shareUrl}
                                title={body}
                            >
                                <WhatsappIcon 
                                    size={32} 
                                    round={true} 
                                />
                            </WhatsappShareButton>
                            <TwitterShareButton
                                url={shareUrl}
                                title={title}
                                hashtags={[hashTag]}
                            > 
                                <XIcon 
                                    size={32} 
                                    round={true} 
                                />
                            </TwitterShareButton>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default RegistrationModal